import axios from 'axios'

const state = {
    lookupUser: null,
    navCounter: null,
    userPreferences: null,
}

const getters = {
    lookupUser (state) {
        return state.lookupUser
    },
    navCounter (state) {
        return state.navCounter
    },
    userPreferences (state) {
        return state.userPreferences
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    // quickly generate a lookup token for lookupUserHandle
    async lookupAuthorization({ dispatch }, handleObj) {
        let response = await axios.post('/users/authorizeLookup', handleObj)
        if(response.data !== null){
            let lookupObj = {
                tokens: response.data.result,
                handle: handleObj.handle
            }
            // return only the generated tokens {lookup and signin} for other actions to use
            if(handleObj.onlyTokens){
                return response.data.result
            }
            return dispatch('lookupUserHandle', lookupObj) 
        }
    },
    
    // lookup a users account via user handle
    async lookupUserHandle({ dispatch, commit, getters }, lookupObj) {
        // empty out some of the already loggedIn users values
        commit('SELLER_ITEMS', null)
        commit('SET_FOLLOWERS', null)
        commit('SET_FOLLOWING', null)
        commit('SET_REVIEWS', null)

        // prepare the user obj to lookup
        let userObj = { handle: lookupObj.handle }

        // append loggedIn users id, to check if the lookupUser blocked the loggedInUser - viewerId
        if(getters.authenticated){ userObj.viewerId = getters.user._id }

        let response = await axios.post('/users/lookup', userObj, {
            headers: {
                'Authorization': `Bearer ${lookupObj.tokens.lookup}`
            }
        })
        if(response.data !== null){
            // fetch the items the lookup user is selling
            let sellerId = response.data.result._id
            dispatch('theSellerItems', sellerId)
            commit('LOOKUP_USER', response.data.result) 

            // fetch the lookup user relationships and reviews here
            let userObj = { userId: response.data.result._id, token: lookupObj.tokens.signin }
            dispatch('myAccountCounter', userObj)
            dispatch('fetchRelationships', userObj)
            dispatch('fetchMyReviews', userObj)
        }
    },

    // close out a looked up user account 
    async closeLookedupUserH({ dispatch, commit, getters }) {
        // fetch the loggedIn user relationships here
        let userObj = { userId: getters.user !== null ? getters.user._id : '' }
        dispatch('myAccountCounter', userObj)
        dispatch('fetchRelationships', userObj)
        dispatch('fetchMyReviews', userObj)

        // removed the lookedUp user items and categories
        commit('SELLER_ITEMS', null) 
        return commit('LOOKUP_USER', null) 
    },
    
    async preferenceSetup({ dispatch }, privacyObj) {
        let response = await axios.post(`/privacy/newPrivacy`, privacyObj)
        if(!response.data.error){     
            dispatch('fetchPreferences')
        }
        return response.data
    },
    
    async fetchPreferences({ commit, getters }) {
        let userObj = { userId: getters.user !== null ? getters.user._id : '' }
        let response = await axios.post(`/privacy/privacySettings`, userObj)
        if(!response.data.error){     
            commit('USER_PREFERENCES', response.data.result)
        }
        return response.data
    },
    
    async updateProfile({ dispatch }, userObj) {
        let response = await axios.put(`/editProfile/profile`, userObj)
        if(JSON.stringify(response.data.result) !== '{}'){     
            return dispatch('updateUserVal', response.data.result)
        }
        return null
    },
    
    async updateHandle({ dispatch }, userObj) {
        let response = await axios.put(`/editProfile/userHandle`, userObj)
        if(JSON.stringify(response.data.result) !== '{}'){     
            return dispatch('updateUserVal', response.data.result)
        }
        return null
    },
    
    async handleSuggestions({ _ }, userObj) {
        let response = await axios.post(`/editProfile/suggestHandles`, userObj)
        return response.data.result
    },
    
    async navbarCounter({ commit }, userObj) {
        let response = await axios.post(`/counts/notificationCounter`, userObj)
        if(!response.data.error){
            commit('NAV_COUNTER', response.data.result)
        }
    }
}

const mutations = {
    LOOKUP_USER: (state, lookupUser) => (state.lookupUser = lookupUser),
    NAV_COUNTER: (state, navCounter) => (state.navCounter = navCounter),
    USER_PREFERENCES: (state, userPreferences) => (state.userPreferences = userPreferences),
}

export default {
    state,
    getters,
    actions,
    mutations
}